import { render, staticRenderFns } from "./ChatLayerSettings.vue?vue&type=template&id=10258f62&scoped=true"
import script from "./ChatLayerSettings.vue?vue&type=script&lang=js"
export * from "./ChatLayerSettings.vue?vue&type=script&lang=js"
import style0 from "./ChatLayerSettings.vue?vue&type=style&index=0&id=10258f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10258f62",
  null
  
)

export default component.exports